module.exports = __webpack_public_path__ + "static/var_hls-1e193d66e33edaa0f3f8b1297f1cf270.svg";